import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import "../../css/styles.css";
import NavBar from "../layout/NavBar";
import Logo from "../layout/Logo";
import { useTranslation } from "react-i18next";
import SideBar from "../layout/SideBar";
import ProductsList from "./ProductsList";
import Reviews from "../layout/Reviews";
import SiteMap from "../layout/SiteMap";
import BackgroundColor from "../layout/Backgroundcolor";
import ResponsiveMenu from "../layout/ResponsiveMenu";
import TopDwonBar from "../layout/TopDwonBar";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { theme } from "../constants/Config";
import { ThemeProvider } from "@material-ui/core/styles";
import sanitizeHtml from "sanitize-html";

function backgroundText(service, city, subtitle) {
  return (
    <div>
      <h1>
        {service} {city}
      </h1>
      <h4>{subtitle}</h4>
    </div>
  );
}

function ServiceInformation({ text, city }) {
  const defaultOptions = {
    allowedTags: ["b", "i", "em", "strong", "a", "p", "h"],
    allowedAttributes: {
      a: ["href"],
    },
    allowedIframeHostnames: ["www.aaronwasserette.nl"],
  };
  const sanitize = (dirty, options) => ({
    __html: sanitizeHtml(dirty, (options: { ...defaultOptions, ...options })),
  });
  const SanitizeHTML = ({ html, options }) => (
    <div dangerouslySetInnerHTML={sanitize(html, options)} />
  );

  return (
    <Container
      maxWidth="lg"
      style={{
        paddingLeft: 0,
        paddingRight: 0,
        borderRadius: 0,
      }}
    >
      <Card
        style={{
          borderRadius: 0,
          backgroundColor: "transparent",
          boxShadow: "none",
        }}
      >
        <CardContent>
          <ThemeProvider theme={theme}>
            <Typography component="div">
              <Box
                className={"scities"}
                textAlign="left"
                style={{
                  marginTop: "10px",
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                {
                  <SanitizeHTML
                    html={text.replace(
                      /Delft/g,
                      city.charAt(0).toUpperCase() + city.slice(1)
                    )}
                  />
                }
              </Box>
            </Typography>
          </ThemeProvider>
        </CardContent>
      </Card>
    </Container>
  );
}

export default function ServicesCities(props) {
  const [drawer, setDrawer] = useState(false);
  const [drawer2, setDrawer2] = useState(false);
  const [t, i18n] = useTranslation();
  const en = props.en;

  useEffect(() => {
    if (en) {
      i18n.changeLanguage("en");
    }
  }, [i18n, en]);

  useEffect(() => {
    document.title = t("stomerijmetatitle");
    window.scrollTo(0, 0);
  }, [t]);

  return (
    <div>
      <SideBar
        open={drawer}
        onClose={() => setDrawer(false)}
        currentPage={"services"}
      />
      <TopDwonBar open={drawer2} onClose={() => setDrawer2(false)} />
      <Grid container direction="column" align="center" wrap="nowrap">
        <Grid item xs={12} className="gradientBG">
          <Logo />
        </Grid>
        <Grid item xs={12} style={{ width: "100%" }}>
          <NavBar currentPage={"services"} openDrawer={setDrawer} />
        </Grid>
        <Grid item xs={12} style={{ zIndex: 1 }}>
          <BackgroundColor
            text={backgroundText(
              t(props.service),
              t(props.city),
              t("stomerijServiceTitlePage2")
            )}
          />
        </Grid>
        <Grid item x={12}>
          <Container maxWidth="lg">
            <Grid container direction="row">
              <Grid item xs={12} md={3} style={{ marginTop: "40px" }}>
                <ResponsiveMenu openDrawer={setDrawer2} />
              </Grid>
              <Grid
                item
                xs={12}
                md={9}
                style={{ marginTop: "15px" }}
                id="mobileproductlistid"
              >
                <ProductsList />
                <ServiceInformation
                  city={props.city}
                  text={t(props.service + "city")}
                />
              </Grid>
            </Grid>
          </Container>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            backgroundColor: "white",
            marginTop: "20px",
            paddingBottom: "60px",
            zIndex: 10,
          }}
        >
          <Reviews />
        </Grid>
        <Grid item xs={12} className="gradientBG" style={{ zIndex: 10 }}>
          <SiteMap t={t} />
        </Grid>
      </Grid>
    </div>
  );
}
